<template>
  <div>
    <div class="page-header">
      <h1>Torsion Springs</h1>
    </div>
    <div class="block block-border-bottom-grey block-pd-sm">
      <div class="row">
        <div class="col-md-8">
          <img
            src="../assets/img/misc/mechanical-torsion-springs.jpg"
            alt="torsion spring"
            class="img-responsive img-thumbnail m-b hidden-xs"
          />
        </div>
        <div class="col-md-4">
          <h4 class="block-title">Manufacturing capabilities</h4>
          <ul class="manufacturing-capabilities">
            <li>Various wire types and diameters in stock up to 0.625”</li>
            <li>Various custom ends available</li>
            <li>Various coating available to increase corrosion protection</li>
            <li>Ability to shot peen to improve fatigue life</li>
            <li>Ability to perform multiple bends on torsion legs</li>
            <li>Custom packaging upon request</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <p class="iso-footer">
            We are an ISO 9001 certified manufacturer of torsion springs for
            various mechanical applications. We produce custom torsion springs
            based on our customer’s needs. We have several advanced CNC coiling
            machines and secondary equipment to produce high quality springs.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MechanicalSpringsTorsion",
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/MechanicalSpringsTorsion.vue